import React, { useState } from "react";
import { FaMobileAlt, FaQuestionCircle } from "react-icons/fa";
import logo from "../assets/images/logo.png";

const Reset2fa = () => {
  const [checked, setChecked] = useState(false);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white rounded-2xl shadow-md p-8 w-[400px]">
        {/* Tillionx Logo */}
        <div className="flex items-center gap-2 mb-6">
          <img
            src={logo}
            alt="Tillionx"
            className="h-16"
          />
        </div>

        {/* Heading */}
        <h2 className="text-3xl font-bold text-gray-900">
          Select Unavailable Methods
        </h2>
        <p className="text-gray-600 text-sm mt-2">
          Please select ALL the security methods that are unavailable and you
          would like to reset.
        </p>

        {/* Option Card */}
        <div className="mt-6 border rounded-xl p-4 flex items-center justify-between hover:shadow-sm">
          <div className="flex items-center gap-3">
            <FaMobileAlt className="text-gray-700 text-lg" />
            <div>
              <p className="font-medium text-gray-900">Phone Number</p>
              <p className="text-sm text-gray-500">987***0346</p>
            </div>
          </div>
          <input
            type="checkbox"
            checked={checked}
            onChange={() => setChecked(!checked)}
            className="w-5 h-5 rounded border-gray-300"
          />
        </div>

        {/* Confirm Button */}
        <button
          disabled={!checked}
          className={`w-full mt-6 py-3 rounded-xl font-medium transition ${
            checked
              ? "bg-yellow-400 text-gray-900 hover:bg-yellow-500"
              : "bg-yellow-100 text-gray-400 cursor-not-allowed"
          }`}
        >
          Confirm Reset
        </button>

        {/* Footer */}
        <div className="flex items-center justify-center mt-4 text-sm text-gray-600">
          <FaQuestionCircle className="mr-2 text-yellow-500" />
          <a href="#" className="text-yellow-600 hover:underline">
            How does this work?
          </a>
        </div>
      </div>
    </div>
  );
};

export default Reset2fa;
